export const apiErrorHandler = (
  error,
  from,
  redirectPath,
  isRedirectToOopsFromService = false
) => {
  if (globalThis.newrelic) {
    globalThis.newrelic.noticeError(error, {errorOrigin: from});
    isRedirectToOopsFromService && (globalThis.location.href = redirectPath);
  }
};
